import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RoleDto} from "../../models/role-models";

@Component({
  selector: 'app-role-item',
  templateUrl: './role-item.component.html',
  styleUrls: ['./role-item.component.scss']
})
export class RoleItemComponent implements OnInit {

  @Input() roleItem: RoleDto | undefined
  @Input() index!: number

  @Output() isOpenModalDeleteRole: EventEmitter<void> = new EventEmitter<void>()

  color = '#6ED1ED'

  ngOnInit() {
    this.setIconColor()
  }

  openDeleteModal(event: MouseEvent) {
    event.stopPropagation()
    this.isOpenModalDeleteRole.emit()
  }

  setIconColor() {
    if (this.index <= 4) {
      this.setIconCodeColor(this.index)
    } else {
      this.setIconCodeColor((this.index % 5))
    }
  }

  setIconCodeColor(code: number) {
    switch (code) {
      case 0:
        this.color = '#6ED1ED'
        break;
      case 1:
        this.color = '#E89D53'
        break;
      case 2:
        this.color = '#5BC59E'
        break;
      case 3:
        this.color = '#7D58DD'
        break;
      case 4:
        this.color = '#E89FE5'
        break;
      default:
        this.color = '#6ED1ED'
        break;
    }
  }
}
